import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import './assets/css/tailwind.css'
import MetaInfo from 'vue-meta-info'
import bottom from '@/components/bottom/index.vue'
import VueI18n from 'vue-i18n'
/* 使用远程语言包的方式 */
import store from './store'
import i18n, { loadSingleLocale } from './i18n'
/* 首页页脚*/
Vue.component('index_bottom', bottom)
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
// 时间格式化
Vue.use(require('vue-moment'))

Vue.use(MetaInfo)

// 开启警告
Vue.config.productionTip = false

Vue.directive('router-a', {
  inserted: function(el) {
    // 只处理站内链接（排除http/https开头的外部链接）
    if (el.tagName === 'A' && el.href && !el.href.startsWith('http')) {
      el.addEventListener('click', function(e) {
        e.preventDefault() // 阻止原生跳转

        // 提取相对路径（去除域名部分）
        const path = el.getAttribute('href') || ''
        if (path) {
          // 跳转前先规范化路径（移除末尾斜杠）
          const normalizedPath = path.replace(/\/+$/, '')
          router.push({ path: normalizedPath })
        }
      })
    }
  }
})

Vue.use(VueI18n) // 注册插件
//
// // 引入语言包
// import enLocale from './locales/en'
// import zhLocale from './locales/zh'
//
// 创建i18n实例（响应式）
// const i18n = new VueI18n({
//   locale: 'en', // 默认语言
//   messages: {
//     en: enLocale,
//     zh: zhLocale
//   }
// })
//
// // 初始化时从 URL 参数获取语言
// function initLang() {
//   const lang = router.currentRoute.query.lang
//   if (lang && ['en', 'zh'].includes(lang)) {
//     Vue.prototype.$i18n.locale = lang
//   }
// }
//
// // 初始化语言
// initLang()
async function initApp() {
  const { pathname, search, hash } = window.location
  // 判断哈希是否为#games（精确匹配），且是首次加载场景
  if (hash.includes('#')) {
    // 构造新的URL：保留路径和查询参数，清除哈希
    window.location.href = `${pathname}${search}`
    return
  }

  // 先获取语言类型列表（存入Vuex）
  const langList = await store.dispatch('fetchLangList')
  // 确保默认语言在列表中，否则用列表第一个语言
  const currentSearch = window.location.search
  const urlParams = new URLSearchParams(currentSearch)
  const defaultLang = urlParams.get('lang') || 'en'
  i18n.locale = (langList.includes(defaultLang) ? defaultLang : langList[0]) || 'en'
  // 加载远程语言包
  await loadSingleLocale(i18n.locale)
  // 挂载应用
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    mounted() {
      document.dispatchEvent(new Event('render-event'))
    },
    render: h => h(App)
  }).$mount('#app')
}

initApp()

// new Vue({
//   el: '#app',
//   router,
//   i18n,
//   mounted() {
//     document.dispatchEvent(new Event('render-event'))
//   },
//   render: h => h(App)
// }).$mount('#app')
